export default {
  computed: {
    routeHash() {
      return this.$route.hash ? this.$route.hash.substring(1) : '';
    },
  },
  
  methods: {
    hidePopup() {
      const { name, params, query } = this.$route;
      this.$router.push({ name, params, query, hash: '' });
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/default/popup/forms/mixin.js